import {AuthPiece} from "aws-amplify-react";
import React from "react";
import request from "superagent";
import APP_ENV from "../Environment";
import SimpleReactValidator from 'simple-react-validator';
import '../App.css';
import {ConfirmUpdateEccAccountComponents} from "../Components/ConfirmUpdateEccAccountComponents";


export default class ConfirmUpdateEccAccount extends AuthPiece {
    constructor(props) {
        super(props);
        this._validAuthStates = ['confirmUpdateEccAccount'];
        this.state = {
            open_input: false,
            email: ""
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.changeEmail = this.changeEmail.bind(this);
        this.handleInputChangeCustom = this.handleInputChangeCustom.bind(this);
        this.validator = new SimpleReactValidator(
            {
                className: 'text-danger',
                messages: {
                    required: "入力必須項目です",
                    email: 'メール形式で入力してください'
                }
            }
        );
    }
    validate() {
        let err  = false;
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            err  = true;
            this.forceUpdate();
        }
        return err;
    }
    changeEmail() {
        const err = this.validate();
        if (err) {
            return;
        }

        this.updateEccEmail(this.props.authData.customer_id, this.state.email)
    }

    updateEccEmail = (customer_id, new_email) => {
        let putData =
        {
            "customer_id": customer_id,  
            "email": new_email                
        }

        request
            .put(APP_ENV.BFF + '/user/attributes')
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .send(putData)
            .end((err, res) => {
                if (err) {
                    console.log(err);
                    this.error("通信エラーです")
                    return;
                }
                window.history.replaceState('','','/');
                this.changeState('updateEmail');
            });
    };

    handleInputChangeCustom(e) {
        console.warn(e.target);
        this.setState({
            [e.target.name] : e.target.value
        });
    }
    handleClose() {
        this.setState({ open_input: false });
    }

    handleShow() {
        this.setState({ open_input: true });
    }
    showComponent(theme) {
        const current_email = this.props.authData.email;
        return (
            <ConfirmUpdateEccAccountComponents theme={theme} currentEmail={current_email}
                                              changeStateFunc={() => {
                                                  window.history.replaceState('','','/');
                                                  this.changeState('sameEmail')
                                              }} handleShow={this.handleShow}
                                              openInput={this.state.open_input} handleClose={this.handleClose}
                                              input_email={this.state.email}
                                              handleInputChangeCustom={this.handleInputChangeCustom}
                                              email_err_msg={this.validator.message("email", this.state.email, 'required|email')}
                                              changeEmail={this.changeEmail}/>
                )
    }
}